export default __webpack_public_path__ + "static/media/loading.1eb8f2c5.gif";